// src/pages/TagTicket.js
import React, { useState } from 'react';
import QRScannerComponent from '../components/QRScannerComponent';
import { db } from '../firebaseConfig';
import { doc, setDoc } from 'firebase/firestore';

const TagTicket = () => {
  const [scannedTicketId, setScannedTicketId] = useState('');
  const [message, setMessage] = useState('');

  const handleScanSuccess = (ticketId) => {
    setScannedTicketId(ticketId);
    setMessage('');
  };

  const handleTag = async (tagType) => {
    if (!scannedTicketId) {
      setMessage('❌ No ticket scanned.');
      return;
    }

    try {
      await setDoc(doc(db, 'ticketTags', scannedTicketId), {
        ticketId: scannedTicketId,
        tag: tagType
      });
      setMessage(`✅ Ticket tagged as "${tagType}" successfully!`);
      setScannedTicketId(''); // Reset for next scan
    } catch (error) {
      console.error('Error tagging ticket:', error);
      setMessage('❌ Failed to tag ticket. Please use an official True Life Retreat Ticket!');
    }
  };

  return (
    <div className="page-background">
      <div className="form-container">
        <h2>Scan Ticket to Tag</h2>
        {!scannedTicketId ? (
          <QRScannerComponent onScanSuccess={handleScanSuccess} />
        ) : (
          <>
            <h3>Ticket ID: {scannedTicketId}</h3>
            <button onClick={() => handleTag('Facilitator')} className="submit-button">
              Tag as Facilitator
            </button>
            <button onClick={() => handleTag('NoShirt')} className="submit-button" style={{ marginTop: '10px' }}>
              Tag as No Shirt
            </button>
          </>
        )}
        {message && <p style={{ marginTop: '20px', color: message.includes('✅') ? 'lightgreen' : 'salmon' }}>{message}</p>}
      </div>
    </div>
  );
};

export default TagTicket;
